import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const initializeMenu = () => {

    document.addEventListener("DOMContentLoaded", function () {
        const menuToggle = document.getElementById("menu-toggle");
        const menuMobile = document.getElementById("menu-mobile");
        const header2 = document.getElementById("header2");
        const menuDesktop = document.getElementById("menu");
        const menuIcon = document.getElementById("menu-icon"); // Ícone "="
        const closeIcon = document.getElementById("close-icon"); // Ícone "X"
    

				let lastScroll = 0;

			function updateHeaderPosition() {
				let currentScroll = window.scrollY;

				if (currentScroll > lastScroll && currentScroll > 80) {
					// rolando pra baixo → esconde o header
					header2.classList.add("hide");
					header2.classList.remove("show");
				} else {
					// rolando pra cima → mostra o header
					header2.classList.add("show");
					header2.classList.remove("hide");
				}

				lastScroll = currentScroll;
			}

        // Função para verificar se está em modo mobile
        function isMobile() {
            return window.innerWidth <= 700;
        }
    
        // Atualiza a visibilidade correta dos menus ao redimensionar
        function updateMenuVisibility() {
            if (isMobile()) {
                // Mobile: esconde o menu desktop e garante que o mobile começa fechado
                menuDesktop.classList.add("hidden");
                menuMobile.classList.add("hidden");
            } else {
                // Desktop: esconde o menu mobile e garante que o desktop começa fechado
                menuMobile.classList.add("hidden");
                menuDesktop.classList.remove("hidden");
            }
    
            // Sempre exibe "=" e esconde "X" ao iniciar
						if (menuIcon) {
            // menuIcon.classList.add("hidden");
						}
						if (closeIcon) {
            // closeIcon.classList.remove("hidden");
						}
        }
    
        // Alterna o menu ao clicar no botão
        menuToggle.addEventListener("click", () => {
            if (isMobile()) {
                // Alterna apenas o menu mobile
                const isOpen = !menuMobile.classList.contains("hidden");
                menuMobile.classList.toggle("hidden", isOpen);
            } else {
                // Alterna apenas o menu desktop
                const isOpen = !menuDesktop.classList.contains("hidden");
                menuDesktop.classList.toggle("hidden", isOpen);
            }
    
            // Alterna ícones
            menuIcon.classList.toggle("hidden");
            closeIcon.classList.toggle("hidden");
        });
    
        // Fecha o menu mobile ao clicar em qualquer link dentro dele
        menuMobile.querySelectorAll("a").forEach(link => {
            link.addEventListener("click", () => {
                if (isMobile()) {
                    menuMobile.classList.add("hidden");
                    menuIcon.classList.remove("hidden");
                    closeIcon.classList.add("hidden");
                }
            });
        });
    
        // Lógica para alternar dropdown
        menuMobile.querySelectorAll('.dropdown-toggle').forEach(button => {
            button.addEventListener('click', function (e) {
                // Evita o comportamento padrão de clique (navegar para o link)
                e.preventDefault();
        
                const dropdownMenu = this.nextElementSibling; // Pega o <ul> do dropdown
        
                // Alterna a visibilidade do dropdown
                dropdownMenu.classList.toggle('hidden');
            });
        });
        
        
    
        // Atualiza a visibilidade ao redimensionar a tela
        window.addEventListener("resize", updateMenuVisibility);
    
        // Inicializa a visibilidade correta ao carregar a página
        updateMenuVisibility();
				// Atualiza a posição do header ao rolar a página
				window.addEventListener("scroll", updateHeaderPosition);
    });
};

export default initializeMenu;
